import { Component, inject } from '@angular/core';
import { CostCategoryService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  CostCategoryCreateDto,
  CostCategoryDto,
  CostCategoryExcelDownloadDto,
  CostCategoryUpdateDto,
} from '../proxy/controlling/dtos/cost-category';
import { COSTCATEGORY_CONFIG, COSTCATEGORY_FIELDS } from './cost-category.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-cost-category',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, CostCategoryService, ConfirmationService],
  templateUrl: './cost-category.html',
  styleUrl: './cost-category.scss',
})
export class CostCategory extends BaseCrudComponent<
  CostCategoryDto,
  CostCategoryCreateDto,
  CostCategoryUpdateDto,
  CostCategoryExcelDownloadDto
> {
  service = inject(CostCategoryService);
  config = COSTCATEGORY_CONFIG;
  fields = COSTCATEGORY_FIELDS;

  protected prepareUpdateDto(data: any, selected: CostCategoryDto): CostCategoryUpdateDto {
    return {
      name: data.name,
      code: data.code,
      tariffsModuleId: data.tariffsModuleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'CostCategory';
  }
}
